// extracted by mini-css-extract-plugin
export default {"tags":"tags__fvTPmU5cNZd4","suiList":"suiList__VWQExEOsERS9"};